<template>
    <figure class="image is-1by1" :class="{ 'transition-up move-up-on-hover': !this.isMobile && !this.isTablet }">
        <div onclick="window.open('https://vobasolutions.de', '_blank')" class="pointer-hand">
            <img src="/img/referenzen-voba-solutions.png" alt="voba solutions GmbH">
        </div>
    </figure>
</template>

<script>
    export default {
        name: 'Referenzen-Kunden-1',
        props: [
            'isMobile',
            'isTablet',
        ],
    }
</script>
